import { render, staticRenderFns } from "./themeSelector.vue?vue&type=template&id=5b6e4a10&scoped=true"
import script from "./themeSelector.vue?vue&type=script&lang=js"
export * from "./themeSelector.vue?vue&type=script&lang=js"
import style0 from "./themeSelector.vue?vue&type=style&index=0&id=5b6e4a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e4a10",
  null
  
)

export default component.exports